import { Form } from 'react-bootstrap';
import CrudFormLayout from '../../../Layout/CrudFormLayout';
import FormLabel from '../../../Text/FormLabel';
import ReactInput from '../../../InputList/ReactInput/ReactInput';
import StatusCheck from '../../StatusCheck';

const BrandForm = ({ apiHandler, editData }) => {
    const initialValues = {
        name: editData?.name || '',
        logo: editData?.logo || '',
        image: editData?.image || '',
        image1: editData?.image1 || '',
        btn_text: editData?.btn_text || '',
        btn_link: editData?.btn_link || '',
        description: editData?.description || '',
        product_link: editData?.product_link || '',
        status: editData ? editData?.status : 1,
    };

    const formHandler = (formValue) => {
        if (apiHandler) {
            return apiHandler(formValue);
        }

        console.log(formValue);
        return null;
    };
    return (
        <CrudFormLayout initialValues={initialValues} apiHandler={formHandler}>
            <Form.Group className='mt-3'>
                <FormLabel title='Name' required />

                <ReactInput name='name' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Brand Logo' required />

                <ReactInput name='logo' type='file' />
            </Form.Group>
            <Form.Group className='mt-3'>
                <FormLabel title='Image1' required />

                <ReactInput name='image' type='file' />
            </Form.Group>
            <Form.Group className='mt-3'>
                <FormLabel title='Image2' required />

                <ReactInput name='image1' type='file' />
            </Form.Group>
            <Form.Group className='mt-3'>
                <FormLabel title='Button Text' required />

                <ReactInput name='btn_text' />
            </Form.Group>
            <Form.Group className='mt-3'>
                <FormLabel title='Button Link' required />

                <ReactInput name='btn_link' />
            </Form.Group>
            <Form.Group className='mt-3'>
                <FormLabel title='Description' required />

                <ReactInput name='description' />
            </Form.Group>
            <Form.Group className='mt-3'>
                <FormLabel title='Product Link' required />

                <ReactInput name='product_link' />
            </Form.Group>

            <StatusCheck />
        </CrudFormLayout>
    );
};

export default BrandForm;
